<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="titularesResiduosPeligrosos"
	[displayWith]="displayTitularResiduosPeligrosos"
	[value]="selectedTitularResiduosPeligrosos"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
